import { Button, CardHeader, Col, FormGroup, Input, Row } from 'reactstrap';
import { Link } from 'react-router-dom';
import useCheckMobileScreen from '../../../hooks/useCheckMobileScreen';
import { DocumentsStateManager } from './DocumentsStateManager';

type HeaderProps = {
  documentsState: DocumentsStateManager;
};

export const DocumentsFolderListHeader = ({ documentsState }: HeaderProps) => {
  const { isMobile } = useCheckMobileScreen();
  return (
    <CardHeader className="bg-white border-0">
      <Row className="align-items-center">
        <Col xs="6">
          <h3 className="mb-0">{documentsState.state.title}</h3>
        </Col>
        <Col className="text-right" xs="6">
          {documentsState.state.currentFolder?.documentsFoldersId && (
            <Link
              to={`${documentsState.state.location}#${documentsState.state.currentFolder?.documentsFoldersId}`}
              onClick={() => {
                documentsState.clearData();
              }}
            >
              <Button color="primary" className="float-right" size="sm">
                Back
              </Button>
            </Link>
          )}
        </Col>
        <Col xs="12" className="mt-2">
          <FormGroup>
            <Input
              className="form-control-alternative"
              id="input-search"
              placeholder="Search"
              type="text"
              onChange={(e) => documentsState.setFilterSearch(e.target.value)}
            />
          </FormGroup>
        </Col>
      </Row>
      {!isMobile ? (
        <Row>
          <Col xs="12">
            {documentsState.state.currentFolder?.documentsFoldersId
              ? documentsState.hasDocumentEditPermission() &&
                !isMobile && (
                  <Button
                    onClick={() => {
                      documentsState.modalFilesShow();
                    }}
                    color="primary"
                  >
                    Add new File
                  </Button>
                )
              : ''}
            {documentsState.hasFolderEditPermission() && (
              <Button
                onClick={() => {
                  documentsState.modalFolderShow();
                }}
                color="primary"
              >
                Add new Folder
              </Button>
            )}
          </Col>
        </Row>
      ) : (
        <></>
      )}
    </CardHeader>
  );
};
